<template lang="pug">
.card-exclusive-container(
  v-if="showBikeTab || showEvbikeTab",
  :class="{'new-module': newModule}"
)
  .title {{moduleTitle}}
  .tabs
    .tab(
      @click="changeTab(1)",
      :class="[active === 1 ? 'active' : 'clear', 'bike']",
      v-if="showBikeTab"
    )
      span 单车
    .tab(
      @click="changeTab(2)",
      :class="[active === 2 ? 'active' : 'clear']",
      v-if="showEvbikeTab"
    )
      span 助力车
  template(v-if="preparing")
    .shadow-cards
      .shadow-cards-item
      .shadow-cards-item
  .body(v-show="!preparing")
    bike-coupons(
      :data="bikeData"
      :new-module="newModule"
    )
  .more.flex-mid(@click="goLink")
    span 查看更多专享福利
    .common-arrow-right
</template>

<script>
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { formatCardTags } from '@/utils/card';
import { getCouponAndCardGroup } from '@/api/fuli';
import { FULI_MODULE, CARD_COUPON_TYPE, FULI_MODULE_NAV } from '../consts';
import { getTokenAndLocation, tryCatch } from '../../../utils';
import { welfareGo } from '../utils';
import BikeCoupons from './bike-coupons';

const mapper = (businessType) => (item) => {
  const {
    isCard,
    price,
    title,
    originalPriceText,
    priceSubText,
    butttonText = '购买',
    cardDetail: detail,
    propertyDetailList: couponDatail,
    buttonLink,
  } = item;
  const biz = businessType || 1;
  const bizImg = biz === 1
    ? 'https://m.hellobike.com/resource/helloyun/15979/8WpgR9V8iL.png'
    : 'https://m.hellobike.com/resource/helloyun/15979/fU_LRYtOXs.png';

  return isCard
    ? {
      type: CARD_COUPON_TYPE.CARD,
      title,
      isCard,
      originPrice: originalPriceText,
      diff: priceSubText,
      corner: 'APP专享',
      btn: butttonText,
      marketingWords: tryCatch(() => formatCardTags(detail.commodityPackageItemDTO), []),
      assets:
          tryCatch(() => detail.commodityPackageItemDTO.paymentLimit, null)
          === 1
            ? '续费16.8元/月，可随时取消'
            : '',
      detail,
      params: {
        shelfGuid: detail.shelfGuid,
        businessType: biz,
        channelCode: biz === 2 ? '102020' : '101020',
        actionOrigin: 'PlatformSellingCard',
      },
      currentPrice: price,
      currentPriceV2: [{ value: price, unit: '元' }],
      bizImg,
    }
    : {
      type: CARD_COUPON_TYPE.COUPON,
      title,
      isCard,
      currentPrice: price,
      currentPriceV2: [{ value: price, unit: '元' }],
      originPrice: originalPriceText,
      diff: priceSubText,
      corner: 'APP专享',
      btn: butttonText,
      buttonLink,
      bizImg,
      amount: (couponDatail || []).reduce(
        (res, { virtualNum }) => res + virtualNum,
        0,
      ),
    };
};

export default {
  components: {
    BikeCoupons,
  },
  props: {
    tab: {
      type: Number,
      default: null,
    },
    newModule: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      active: 1,
      preparing: true,
      bikes: [], // 单车列表
      evbike: [], // 助力车列表
      showBikeTab: true,
      showEvbikeTab: true,
      isQueryTab: false,
    };
  },
  computed: {
    bikeData() {
      return this.active === 1 ? this.bikes : this.evbike;
    },
    moduleTitle() {
      if (this.newModule) {
        return 'APP专享卡券';
      }
      return 'APP专享福利专区';
    },
  },
  watch: {
    tab(v) {
      if (v) {
        this.active = Number(v);
      }
    },
  },
  created() {
    this.isQueryTab = this.queryTab();
  },
  methods: {
    changeTab(index) {
      this.active = index;

      UBT.clickButton({
        pageId: 'Welfare',
        buttonName: 'platform_tab',
        categoryId: 'platform',
        businessInfo: {
          business: index,
        },
      });
    },
    async start() {
      return this.getData().then(() => {
        this.preparing = false;
      });
    },
    async getData() {
      const { token, adCode, cityCode } = await getTokenAndLocation();
      return getCouponAndCardGroup({
        token,
        adCode,
        cityCode,
      })
        .then((v) => {
          this.showBikeTab = false;
          this.showEvbikeTab = false;
          if (v && v.data) {
            (v.data.couponAndCard || []).forEach((item) => {
              // 单车
              if (item.businessType === 1) {
                this.bikes = item.cardsInfo.map(mapper(item.businessType));

                if (this.bikes.length) {
                  this.showBikeTab = true;
                }
              }
              // 助力车
              if (item.businessType === 2) {
                this.evbike = item.cardsInfo.map(mapper(item.businessType));

                if (this.evbike.length) {
                  this.showEvbikeTab = true;
                }

                // 更多跳转链接
                if (item.moreLink) {
                  this.link = item.moreLink;
                }
              }
            });

            // 不传参，默认使用接口返回
            if (!this.isQueryTab && !this.tab) {
              // 仅有单车tab
              if (this.showBikeTab && !this.showEvbikeTab) {
                this.active = v.data.defaultTab === 1 ? v.data.defaultTab : 1;
              } else if (!this.showBikeTab && this.showEvbikeTab) {
                // 仅有助力车tab
                this.active = v.data.defaultTab === 2 ? v.data.defaultTab : 2;
              } else {
                this.active = v.data.defaultTab;
              }
            }
          }
        })
        .catch(() => {
          this.showBikeTab = false;
          this.showEvbikeTab = false;
        })
        .finally(() => {
          if (!(this.showBikeTab || this.showEvbikeTab)) {
            this.$emit('hideTab', FULI_MODULE_NAV.welfare_exclusive_new);
          }
        });
    },
    goLink() {
      UBT.clickButton({
        pageId: 'Welfare',
        buttonName: 'more_APPcard',
        categoryId: 'platform',
        businessInfo: {},
      });

      welfareGo(
        this.link
          || 'http://m.hellobike.com/AppPlatformH5/latest/index.html#/card-for-app?source=flzx&openType=webview',
      );
    },
    queryTab() {
      const { tab, to } = this.$route.query;

      if (to === FULI_MODULE.welfare_exclusive && tab !== undefined) {
        this.active = Number(tab);
        return true;
      }

      return false;
    },
  },
};
</script>

<style lang="less" scoped>
.card-exclusive-container {
  padding: 0.2rem 0.16rem 0.16rem;

  .shadow-cards-item {
    width: 100%;
    height: 0.71rem;
    background: #f7f9fa;
    border-radius: 0.04rem;

    &:not(:last-of-type) {
      margin-bottom: 0.08rem;
    }
  }

  .title {
    font-size: 0.18rem;
    color: #242729;
    margin-bottom: 0.14rem;
    font-weight: 500;
  }

  .tabs {
    display: flex;
    font-size: 0.14rem;
    font-weight: 500;
    color: #242729;
    position: relative;
    margin-bottom: 0.2rem;

    .tab {
      width: 0.41rem;
      display: flex;
      align-items: center;
      position: relative;

      &:not(:first-of-type) {
        margin-left: 0.32rem;
      }

      span {
        white-space: nowrap;
      }

      img {
        width: 100%;
      }

      &::after {
        content: "";
        display: block;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: -0.04rem;
        width: 0;
        height: 0.02rem;
        background: #08f;
        border-radius: 0.02rem;
        transition: width 0.2s ease-in-out;
      }

      &.active::after {
        width: 0.18rem;
      }

      &.clear {
        color: #879099;
        font-weight: normal;
      }
    }

    .bike {
      width: 0.28rem;
    }

    .hover-bar {
      width: 0.18rem;
      height: 0.02rem;
      background: #08f;
      border-radius: 0.02rem;
      position: absolute;
      left: 0.16rem;
      top: 0.2rem;
      transition: transform 200ms ease-in-out;
    }
  }

  .more {
    font-size: 0.12rem;
    color: #999;
    margin-top: 0.16rem;

    * {
      border-color: #999 !important;
    }
  }

  .card-item {
    margin-bottom: 0.12rem;
  }

  &.new-module {
    padding-top: 0.13rem;

    .title {
      font-size: 0.16rem;
      margin-bottom: 0.1rem;
    }

    .tabs {
      color: #ff5526;
      font-weight: 500;

      .tab {
        &::after {
          background: #ff5526;
        }

        &:not(:first-of-type) {
          margin-left: 0.2rem;
        }

        &.clear {
          color: #5a6066;
        }
      }
    }

    .more {
      margin-top: 0.15rem;
    }
  }
}
</style>
